import { render, staticRenderFns } from "./Bgg_Rank.vue?vue&type=template&id=47a067f0&scoped=true"
import script from "./Bgg_Rank.vue?vue&type=script&lang=js"
export * from "./Bgg_Rank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a067f0",
  null
  
)

export default component.exports